export default [
    {
        title: 'Was ist die NEW-Laufserie 2026? ',
        content: 'Die NEW-Laufserie ist eine Reihe von fünf Laufevents in der Region, bei denen Läufer:innen an 10-km-Läufen teilnehmen können. Die Serie beginnt am 14.02.2026 und endet am 14.06.2026.',
    },
    {
        title: 'Wie kann ich mich anmelden? ',
        content: '<p>Man muss sich für jeden der 10-km-Läufe direkt beim jeweiligen Veranstalter anmelden.</p>' +
            '<ul>' +
            '<li><a target="_blank" href="https://www.hkl-mg.de/anmeldung/">14.02.2026: Hardter Karnevalslauf</a></li>' +
            '<li><a target="_blank" href="https://www.apfelbluetenlauf.de/anmeldung/">19.04.2026: Apfelblütenlauf</a></li>' +
            '<li><a target="_blank" href="https://citylauf-korschenbroich.com/anmeldung/">24.06.2026: Korschenbroicher City-Lauf</a></li>' +
            '<li><a target="_blank" href="https://rahser-run.de/">31.05.2026: Ra(h)ser-Run</a></li>' +
            '<li><a target="_blank" href="https://www.tv-erkelenz.de/">14.06.2026: NEW-Citylauf Erkelenz</a></li>' +
            '</ul><br>' +
            '<p>Zusätzlich muss man sich über das Anmeldeformular auf unserer Seite <a target="_blank" href="https://www.new.de/laufserie">NEW Laufserie 2026</a> für die gesamte Laufserie registrieren.</p>'
    },
    {
        title: 'Was ist der „NEW-Teamrun“? ',
        content: 'Um beim NEW-Teamrun dabei zu sein, stellt ein Verein ein Team von 3 Personen auf und meldet sich auf unserer Webseite mit dem entsprechenden Anmeldeformular an. Im Nachgang meldet man sich bei jedem der 10-km-Läufe (mindestens 3) direkt beim jeweiligen Veranstalter einzeln an. Gewertet werden die drei schnellsten Teamläufe, der einzelnen Laufveranstaltungen der NEW-Laufserie 2026.'
    },
    {
        title: 'Fließt die Einzelwertung innerhalb des NEW-Teamcups automatisch in die Gesamtwertung der NEW-Laufserie ein? ',
        content: 'Nein. Um auch alleine gewertet zu werden, musst man sich zusätzlich als Einzelperson bei der NEW-Laufserie anmelden. '
    },
    {
        title: 'Was sind die Teilnahmebedingungen?',
        content: 'Um in die Gesamtwertung zu kommen, muss man an mindestens drei von fünf Läufen teilnehmen. Dabei ist es egal, ob man Bestzeiten läuft oder einfach nur Spaß haben möchte. \n' +
            '\n' +
            'Mit der Anmeldung zur NEW-Laufserie 2026 erklärt man sich damit einverstanden, dass die NEW personenbezogenen Daten an Partner weitergeben dürfen, die an der Durchführung der einzelnen Läufe beteiligt sind (zum Beispiel die Zeitnehmer). Diese übermitteln uns auch die Ergebnisse, damit wir die offiziellen Ergebnislisten für die NEW-Laufserie 2026 erstellen können. Veröffentlicht werden dabei nur die Angaben, die für die Wertung notwendig sind. Bei weiteren Fragen findet man hier unsere Datenschutzhinweise: <a target="_blank" href="https://datenschutz.new.de/new-de">NEW Datenschutz</a>'
    },
    {
        title: 'Wann und wo findet die Siegerehrung statt?',
        content: 'Die Siegerehrung erfolgt beim letzten Lauf, dem NEW-Citylauf in Erkelenz am 14.06.2026, auf der NEW-Bühne.'
    },
    {
        title: 'Gibt es Preise für die Teilnehmer?',
        content: 'Ja, neben Geldpreisen für die schnellsten Läufer gibt es auch eine Verlosung von tollen Preisen, an der alle Teilnehmer automatisch teilnehmen.  '
    },
    {
        title: 'Bis wann kann man sich für die Laufserie anmelden?',
        content: 'Eine Anmeldung ist bis zum dritten Lauf der Serie (26.04.2026: Internationaler Korschenbroicher City-Lauf) möglich.'
    },
    {
        title: 'Für wen ist die NEW-Laufserie geeignet?',
        content: 'Die NEW-Laufserie ist für alle geeignet, ob Anfänger:in oder erfahrene:r Läufer:in. Es geht um den gemeinsamen Spaß am Laufen und die besondere Atmosphäre der Events.'
    }
]
